export interface Tool {
  id: string;
  name: string;
  code: string;
  icon: string;
  description?: string;
  category?: string;
  imageUrl?: string;
  available?: boolean;
  metadata?: Record<string, unknown>;
}

export interface ToolsApiResponse {
  tools: Tool[];
  totalTools: number;
  metadata?: {
    modelId?: string;
    version?: string;
    lastUpdated?: string;
    language?: string;
  };
}

export function generateMockTools(): Tool[] {
  return [
    { id: 'laser-calibrator', name: 'Laser Calibrator', code: 'LC-900-X', icon: 'biotech', category: 'Calibration', available: true },
    { id: 'torque-wrench', name: 'Torque Wrench', code: 'TW-450-D', icon: 'build', category: 'Assembly', available: true },
    { id: 'digital-multimeter', name: 'Digital Multimeter', code: 'DM-PRO', icon: 'rebase_edit', category: 'Diagnostics', available: true },
    { id: 'alignment-jig', name: 'Alignment Jig', code: 'AJ-V4-SET', icon: 'grid_view', category: 'Alignment', available: true },
    { id: 'firmware-uploader', name: 'Firmware Uploader', code: 'FW-LINK', icon: 'upload_file', category: 'Software', available: true },
    { id: 'thermal-camera', name: 'Thermal Camera', code: 'TC-88-IR', icon: 'thermostat', category: 'Inspection', available: true },
    { id: 'micro-screwdriver', name: 'Micro-Screwdriver Set', code: 'MS-PRECISION', icon: 'hand_package', category: 'Assembly', available: true },
    { id: 'soldering-station', name: 'Soldering Station', code: 'SS-400-W', icon: 'flare', category: 'Electrical', available: true },
  ];
}
